/**
 * 00突 Top6（与插件主面板 sudden mutation 区一致）
 * 规则A：time_1 无红 且 (time_0 或 time_-1) 红
 * 规则B：time_1 无红 且 time_0 绿
 * 排序：time_0.add_value 大→小；热/温/冷按独前 win_r18
 */

export const SUDDEN_MUTATION_MAX_DISPLAY = 6;

/** 热 <10；温 10~20；冷 ≥20 或无效 */
export function mut00HeatBucket(duQian) {
  const o = Number(duQian);
  if (Number.isFinite(o) && o > 0 && o < 10) return 'hot';
  if (Number.isFinite(o) && o >= 10 && o < 20) return 'warm';
  return 'cold';
}

function getSpecSpectrum(horse, timeKey, specType) {
  const v = horse?.time_series?.[timeKey]?.spectrum?.[specType];
  if (v === undefined || v === null || v === '') return 0;
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
}

function isSpectrumRed(spectrumVal) {
  return spectrumVal === 3 || spectrumVal === 4;
}

function isSpectrumGreen(spectrumVal) {
  return Number(spectrumVal) === 2;
}

function matchesSuddenRuleRed(h, specType) {
  const s1 = getSpecSpectrum(h, 'time_1', specType);
  const s0 = getSpecSpectrum(h, 'time_0', specType);
  const sMinus1 = getSpecSpectrum(h, 'time_-1', specType);
  return !isSpectrumRed(s1) && (isSpectrumRed(s0) || isSpectrumRed(sMinus1));
}

function matchesSuddenRuleGreen(h, specType) {
  const s1 = getSpecSpectrum(h, 'time_1', specType);
  const s0 = getSpecSpectrum(h, 'time_0', specType);
  return !isSpectrumRed(s1) && isSpectrumGreen(s0);
}

function duQianOddsForStyle(h, ts) {
  const r18 = Number(h?.odds?.win_r18);
  if (Number.isFinite(r18) && r18 > 0) return r18;
  if (ts && ts.win_odds !== undefined && ts.win_odds !== null && ts.win_odds !== '') {
    const wo = Number(ts.win_odds);
    if (Number.isFinite(wo) && wo > 0) return wo;
  }
  const w = Number(h?.odds?.win);
  return Number.isFinite(w) && w > 0 ? w : 0;
}

export function buildSuddenMutationRows(horses) {
  if (!Array.isArray(horses)) return [];
  const rows = [];
  for (let i = 0; i < horses.length; i++) {
    const h = horses[i];
    const num = parseInt(h?.number, 10);
    if (Number.isNaN(num) || num <= 0) continue;
    const redQin = matchesSuddenRuleRed(h, 'spec_qin');
    const redQpl = matchesSuddenRuleRed(h, 'spec_qpl');
    const greenQin = matchesSuddenRuleGreen(h, 'spec_qin');
    const greenQpl = matchesSuddenRuleGreen(h, 'spec_qpl');
    if (!redQin && !redQpl && !greenQin && !greenQpl) continue;
    const ts0 = h.time_series && h.time_series.time_0;
    const addRaw = ts0 && ts0.add_value !== undefined && ts0.add_value !== null && ts0.add_value !== ''
      ? Number(ts0.add_value)
      : NaN;
    const duQian = duQianOddsForStyle(h, ts0 || null);
    rows.push({
      number: num,
      duQian,
      addValue: Number.isFinite(addRaw) ? addRaw : null,
      bucket: mut00HeatBucket(duQian),
    });
  }
  rows.sort((a, b) => {
    const av = Number.isFinite(Number(a.addValue)) ? Number(a.addValue) : -Infinity;
    const bv = Number.isFinite(Number(b.addValue)) ? Number(b.addValue) : -Infinity;
    return (bv - av) || (a.duQian - b.duQian) || (a.number - b.number);
  });
  return rows;
}

export function getSuddenMutationDisplayRows(horses, topN = SUDDEN_MUTATION_MAX_DISPLAY) {
  const n = Number(topN);
  const limit = Number.isFinite(n) && n > 0 ? n : SUDDEN_MUTATION_MAX_DISPLAY;
  return buildSuddenMutationRows(horses).slice(0, limit);
}

/**
 * @returns {{ cold: number[], warm: number[], hot: number[], all: number[] }}
 */
export function collectSuddenMutationBuckets(horses, topN = SUDDEN_MUTATION_MAX_DISPLAY) {
  const shown = getSuddenMutationDisplayRows(horses, topN);
  const cold = [];
  const warm = [];
  const hot = [];
  const all = [];
  for (let i = 0; i < shown.length; i++) {
    const it = shown[i];
    const num = Number(it.number);
    if (!Number.isFinite(num) || num <= 0) continue;
    all.push(num);
    if (it.bucket === 'hot') hot.push(num);
    else if (it.bucket === 'warm') warm.push(num);
    else cold.push(num);
  }
  return { cold, warm, hot, all };
}
